import styled from 'styled-components';

export const ResourceContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const ResourceTitleWrapper = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const ResourceContentWrapper = styled.div`
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const AnswersList = styled.ol`
  margin: 0;
  padding-left: 20px;
`;
